const permissions = {
  viewOptimizations: 'OO001',
  addOptimizations: 'OO002',
  editOptimizations: 'OO003',
  deleteOptimizations: 'OO004'
};

export default permissions;
